// @flow
import React from 'react'
import Immutable from 'seamless-immutable'

// components
import { FieldLabel } from '../../Components/'
import { Number } from '../../Components/_formFields'

// types
import type { DefaultMiniAppProps } from './'

type SeatsMiniAppProps = DefaultMiniAppProps & {
  miniAppData: {
    cicEnableAppTextMode?: boolean,
    invalidFields: Array<string>,
  }
}

export default class SeatsMiniApp extends React.Component<SeatsMiniAppProps> {
  static defaultProps = {
    isBackOffice: false,
  }

  handleOnChange = (value: string) => {
    const { formData, onChangeFormData } = this.props
    let changedFormData = formData
    if (!formData.set) {
      changedFormData = Immutable(changedFormData)
    }
    changedFormData = changedFormData.set('seats', value)
    changedFormData = Object.keys(changedFormData).filter(key => key !== 'seats').reduce((acc, insuranceKey) => {
      if (acc[insuranceKey] && acc[insuranceKey].seats) {
        return acc.setIn([insuranceKey, 'seats'], value)
      }
      return acc
    }, changedFormData)
    onChangeFormData(changedFormData, ['seats'])
  }

  render() {
    const { content, miniAppData, specification, formData } = this.props

    if (miniAppData && miniAppData.cicEnableAppTextMode) {
      return null
    }

    const seatsValue = formData ? formData.seats : ''

    let seatsError = {}
    if (miniAppData && miniAppData.invalidFields && miniAppData.invalidFields.includes('seats')) {
      seatsError = {
        seats: {
          'error_type': 'required_field_missing'
        }
      }
    }

    return ([
      <div className='form-group d-flex flex-row flex-wrap flex-sm-row align-items-center' key='SeatsMiniApp-content'>
        <FieldLabel
          id='seats-miniApp'
          isRequired
          label={content.fieldNames.seats}
        />
        <div className='col-12 col-sm-5 order-3 order-sm-0 offset-sm-1 mt-2 mt-sm-0 pr-sm-0'>
          <Number
            {...specification}
            enabled
            id='seats-miniApp'
            isPristine={false}
            name='seats'
            onChange={this.handleOnChange}
            prefix=''
            validationErrors={seatsError}
            value={seatsValue}
          />
        </div>
      </div>
    ])
  }
}
